// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"672":"3ee42562","825":"6056fdbd","830":"8e75ed20","854":"31b1d308","922":"3e44f2e1"}[chunkId] + ".css";
};